import React from "react";
import { Navigate } from "react-router-dom";

const RestrictedRoute = ({ user, allowedRoles, children }: any) => {

    if (!allowedRoles.includes(user?.role) && user) {
        return <Navigate to="/user-project-list" replace />;
    }
    return children;
};

export default RestrictedRoute;
